module.exports = __webpack_public_path__ + "img/b.afe79482.png";